const vendorDetailFields = [
  {
    label: 'Nama Vendor',
    name: 'name',
    placeholder: 'Nama Vendor',
    validation: "bail|required|multipleSpaces|max:50,length"
  },
  {
    label: 'Kode Vendor',
    name: 'pairing_code',
    placeholder: 'Kode Vendor',
    validation: "max:128,length",
  },
  {
    label: 'Alamat',
    name: 'address',
    placeholder: 'Alamat',
    validation: "bail|multipleSpaces|max:100,length",
  },
  {
    label: 'NPWP',
    name: 'npwp',
    validation: "bail|max:20,length",
    placeholder: '__.___.___._-___.___',
    mask: '00.000.000.0-000.000',
  },
  {
    label: 'Status Vendor',
    labelPosition: 'before',
    name: 'status',

    type: 'switch',
    valueLabelTrue: 'Aktif',
    valueLabelFalse: 'Non Aktif',
    customValueFn: (obj) => {
      if (!obj.status) return
      return obj.status.name == 'Aktif' ? 'ACTIVE' : 'INACTIVE'
    },
  },
  {
    label: 'PIC Vendor',
    name: 'contact_person_name',
    placeholder: 'PIC Vendor',
    validation: "bail|multipleSpaces|max:50,length"
  },
  {
    label: 'Nomor HP',
    name: 'phone_number',
    validation: "bail|number|max:14,length",
    mask: '00000000000000'
  },
  {
    label: 'Email',
    name: 'email',
    placeholder: 'Email',
    validation: "bail|optional|max:50,length|email"
  },
]

export default vendorDetailFields
